import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { LandingPage } from './components/LandingPage';
import './styles.css';

const isLandingPage = window.location.pathname === '/';
document.body.classList.toggle('marketing-body', isLandingPage);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {isLandingPage ? <LandingPage /> : <App />}
  </StrictMode>,
);
